module.exports = __webpack_public_path__ + "img/authentication.376a2c0c.png";